export const RouterName = {
  HomePage: {
    url: "/",
  },
  Payment: {
    url: "/payment",
    Cart: {
      key: "cart",
      url: "/payment/cart",
    },
    Checkout: {
      key: "checkout",
      url: "/payment/checkout",
    },
    Completed: {
      key: "completed",
      url: "/payment/completed",
    },
    Success: {
      key: "success",
      url: "/payment/success",
    },
  },
  Auth: {
    url: "/auth/login",
  },
  ProductDetail: {
    url: "/product-detail",
  },
  Products: {
    url: "/products",
    search: {
      key: "searchProducts",
      url: "/products/search",
    },
    sale: {
      key: "saleProducts",
      url: "/products/sale",
    },
    category: {
      key: "categoryProducts",
      url: "/products/category",
    },
  },
  ReturnPolicies: {
    url: "/return-policies",
  },
  DeliveryAndPayment: {
    url: "/delivery-and-payment",
  },
};
